
export const RecentContent = {
  onLoad: function() {
    if (!$('body.template-recent-content').length) {
      return
    }
    this.initHeroSlider()
  },
  initHeroSlider: function() {
    $('#hero-carousel').slick({
      arrows: false,
      dots: true,
      dotsClass: 'slick-dots active-dot-color_white left-of-arrow',
    })
    $('#hero-carousel').css('visibility', 'visible')
  },
}



// WEBPACK FOOTER //
// ./scripts/modules/RecentContent.js